export default "__VITE_ASSET__UiX74mDj__"